var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Switch } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import isActionAllowed from "../../../../../../../core/authorization/userPermissions";
import { REPORT_CREATION, REPORT_EDIT, } from "../../../../../../../core/constants/permissionConstants";
import { ResponseStatusCodes } from "../../../../../../../core/constants/responseStatusCodes";
import { editTrackedItemsRoute } from "../../../../../../../core/constants/routesPath";
import isEmpty from "../../../../../../../core/helpers/isEmpty";
import localize from "../../../../../../../core/utils/translation-files";
import TableActions from "../../../../../../../layout/components/customTable/tableActions";
import UseCustomPagination from "../../../../../../../layout/components/hooks/useCustomPagination";
import { notifications } from "../../../../../../../layout/components/notifications";
import { inActivateTrackedItem, activateTrackedItem, } from "../../../../../../../redux/trackedItem/actions";
import SystemCreatedtrackedItemTable from "./components/systemCreatedtrackedItemTable";
import { TrackedItemApi } from "../../../../../../../core/api/trackedItemApi";
import { TrackedItemsVariables } from "../../../../../../../core/constants/TrackedItemsConstants";
const SystemCreatedTrackedItemsListingContainer = ({ filters, inActivateTrackedItem, activateTrackedItem, isSubmitAction, setIsSubmitAction, isPrintMode, selectedTag, lastActionType, }) => {
    var _a, _b;
    const history = useHistory();
    const [systemCreatedItems, setSystemCreatedItems] = useState([]);
    const isFirstRender = useRef(true);
    const searchDebounceRef = useRef(null);
    const prevSearchValueRef = useRef("");
    const hadActiveSearchRef = useRef(false);
    const skipNextClearFetchRef = useRef(false);
    //  const searchValue = useSelector(
    //   (state: RootStateOrAny) => state?.searchInput
    // );
    const queryParams = (_a = history.location.state) === null || _a === void 0 ? void 0 : _a.queryParams;
    const searchValue = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.searchInput) || "";
    const _c = UseCustomPagination({
        totalRecords: (_b = systemCreatedItems === null || systemCreatedItems === void 0 ? void 0 : systemCreatedItems.length) !== null && _b !== void 0 ? _b : 0,
        clientPagination: true,
    }), { handleCustomTablePropChange } = _c, restPaginationProps = __rest(_c, ["handleCustomTablePropChange"]);
    const handleGetSystemTrackItem = useCallback(() => {
        const { groupId, companyId, siteId } = filters;
        if (!isEmpty(groupId)) {
            const trimmedSearch = searchValue ? searchValue.trim() : "";
            let searchType;
            let keyword = "";
            const hasSearch = trimmedSearch && trimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH;
            const hasTag = !!selectedTag;
            if (hasSearch && hasTag) {
                // Both are active, use the latest one
                if (lastActionType === "search") {
                    searchType = "reportName";
                    keyword = trimmedSearch;
                }
                else if (lastActionType === "tag") {
                    searchType = "reportTag";
                    keyword = selectedTag;
                }
                else {
                    // No lastActionType, default to search
                    searchType = "reportName";
                    keyword = trimmedSearch;
                }
            }
            else if (hasSearch) {
                // Only search is active
                searchType = "reportName";
                keyword = trimmedSearch;
            }
            else if (hasTag) {
                // Only tag is active
                searchType = "reportTag";
                keyword = selectedTag;
            }
            if (keyword || searchType) {
                const additionalParams = Object.assign({}, (searchType ? { searchType: searchType } : {}));
                console.log("Calling system-created search endpoint with params:", Object.assign({ groupId, companyId: companyId !== null && companyId !== void 0 ? companyId : -1, siteId: siteId !== null && siteId !== void 0 ? siteId : -1, keyword, searchType: searchType }, additionalParams));
                TrackedItemApi.searchSystemTrackedItems(groupId, companyId !== null && companyId !== void 0 ? companyId : -1, siteId !== null && siteId !== void 0 ? siteId : -1, keyword, additionalParams)
                    .then((response) => {
                    var _a, _b, _c, _d;
                    console.log("System-created search response:", {
                        params: { groupId, companyId: companyId !== null && companyId !== void 0 ? companyId : -1, siteId: siteId !== null && siteId !== void 0 ? siteId : -1, keyword },
                        response,
                        responseType: typeof response,
                        isArray: Array.isArray(response),
                        responseLength: Array.isArray(response)
                            ? response.length
                            : "Not an array",
                    });
                    if (!isEmpty(response)) {
                        if (Array.isArray(response)) {
                            if (response.length > 0 && ((_a = response[0]) === null || _a === void 0 ? void 0 : _a.data) !== undefined) {
                                setSystemCreatedItems((_c = (_b = response[0]) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : []);
                            }
                            else {
                                setSystemCreatedItems(response);
                            }
                        }
                        else if (response === null || response === void 0 ? void 0 : response.data) {
                            setSystemCreatedItems((_d = response.data) !== null && _d !== void 0 ? _d : []);
                        }
                        else {
                            setSystemCreatedItems([]);
                        }
                    }
                    else {
                        setSystemCreatedItems([]);
                    }
                })
                    .catch((error) => {
                    console.error("System-created search API error:", error);
                });
            }
            else {
                if (trimmedSearch && trimmedSearch.length > 0 && trimmedSearch.length < TrackedItemsVariables.MINIMUM_SEARCH_LENGTH) {
                    console.log("Skipping system-created search - keyword must be at least 3 characters:", trimmedSearch);
                }
                // Default fetch (no search or tag)
                const defaultParams = {};
                console.log("Calling system-created search endpoint with default params:", Object.assign({ groupId, companyId: companyId !== null && companyId !== void 0 ? companyId : -1, siteId: siteId !== null && siteId !== void 0 ? siteId : -1 }, defaultParams));
                TrackedItemApi.searchSystemTrackedItems(groupId, companyId !== null && companyId !== void 0 ? companyId : -1, siteId !== null && siteId !== void 0 ? siteId : -1, "", defaultParams)
                    .then((response) => {
                    var _a, _b, _c, _d;
                    if (!isEmpty(response)) {
                        if (Array.isArray(response)) {
                            if (response.length > 0 && ((_a = response[0]) === null || _a === void 0 ? void 0 : _a.data) !== undefined) {
                                setSystemCreatedItems((_c = (_b = response[0]) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : []);
                            }
                            else {
                                setSystemCreatedItems(response);
                            }
                        }
                        else if (response === null || response === void 0 ? void 0 : response.data) {
                            setSystemCreatedItems((_d = response.data) !== null && _d !== void 0 ? _d : []);
                        }
                        else {
                            setSystemCreatedItems([]);
                        }
                    }
                    else {
                        setSystemCreatedItems([]);
                    }
                })
                    .catch((error) => {
                    console.error("System-created search API error:", error);
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, searchValue, selectedTag, lastActionType]);
    useEffect(() => {
        if ((isFirstRender.current || isSubmitAction) && !isEmpty(filters)) {
            handleGetSystemTrackItem();
            skipNextClearFetchRef.current = true;
            isFirstRender.current = false;
            setIsSubmitAction(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [handleGetSystemTrackItem, filters, isSubmitAction]);
    // useEffect(() => {
    //   if (!isEmpty(filters) && !isEmpty(filters.groupId)) {
    //     handleGetSystemTrackItem();
    //   }
    //   // eslint-disable-next-line react-hooks-exhaustive-deps
    // }, [selectedTag]);
    useEffect(() => {
        // if (searchDebounceRef.current) {
        //   clearTimeout(searchDebounceRef.current);
        // }
        const trimmedSearch = searchValue ? searchValue.trim() : "";
        const prevTrimmedSearch = prevSearchValueRef.current;
        if (!isEmpty(filters) && !isEmpty(filters.groupId)) {
            if (trimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH) {
                // searchDebounceRef.current = setTimeout(() => {
                handleGetSystemTrackItem();
                // }, TrackedItemsVariables.SEARCH_DEBOUNCE_TIME);
                skipNextClearFetchRef.current = false;
                hadActiveSearchRef.current = true;
            }
            else if (trimmedSearch.length === 0 &&
                (prevTrimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH ||
                    hadActiveSearchRef.current)) {
                if (skipNextClearFetchRef.current) {
                    skipNextClearFetchRef.current = false;
                }
                else {
                    hadActiveSearchRef.current = false;
                    handleGetSystemTrackItem();
                }
            }
        }
        prevSearchValueRef.current = trimmedSearch;
        // return () => {
        //   if (searchDebounceRef.current) {
        //     clearTimeout(searchDebounceRef.current);
        //   }
        // };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTag, filters]);
    const inActivateTrackedItemHandler = (data) => {
        inActivateTrackedItem(data).then((response) => {
            if (response &&
                response.code === ResponseStatusCodes.DATA_CONSTRAINT_VIOLATION) {
                return;
            }
            else {
                handleGetSystemTrackItem();
                notifications.success(localize(["TrackedItem.trackeditem", "disabled", "successfully"]));
            }
        });
    };
    const activateTrackedItemHandler = (data) => {
        activateTrackedItem(data).then((response) => {
            if (response &&
                response.code === ResponseStatusCodes.DATA_CONSTRAINT_VIOLATION) {
                return;
            }
            else {
                handleGetSystemTrackItem();
                notifications.success(localize(["TrackedItem.trackeditem", "enabled", "successfully"]));
            }
        });
    };
    const editTrackedItemRedirect = (trackedItem) => {
        history.push(editTrackedItemsRoute + trackedItem.id, {
            trackedItemId: trackedItem.id,
            systemCreated: true,
        });
    };
    const trackedItemActions = (trackedItem) => {
        const actionArray = [
            {
                priority: 2,
                title: ["edit", "TrackedItem.trackedItem"],
                onClick: editTrackedItemRedirect.bind({}, trackedItem),
                svgIcon: "Edit",
                isAllowed: isActionAllowed([REPORT_EDIT]),
            },
            {
                priority: 1,
                title: trackedItem.disabled === true
                    ? ["unArchive", "TrackedItem.trackedItem"]
                    : ["archive", "TrackedItem.trackedItem"],
                isModal: true,
                modalTitle: [
                    "areYouSureTo",
                    `${trackedItem.disabled === true ? ["unarchive"] : ["Archive"]}`,
                    "TrackedItem.thisTrackedItem?",
                ],
                isAllowed: isActionAllowed([REPORT_CREATION]),
                onConfirm: trackedItem.disabled === true
                    ? activateTrackedItemHandler.bind({}, trackedItem.id)
                    : inActivateTrackedItemHandler.bind({}, trackedItem.id),
                disbaled: !trackedItem.belongsToHoldingCompany,
                children: (React.createElement(Switch, { disabled: !trackedItem.belongsToHoldingCompany, checked: trackedItem.disabled === false, className: `ml-1 ${!trackedItem.belongsToHoldingCompany ? `disableSwitch` : ``}` })),
            },
        ];
        return React.createElement(TableActions, { actionArray: actionArray });
    };
    return (React.createElement("div", null,
        React.createElement(SystemCreatedtrackedItemTable, { data: systemCreatedItems, actions: trackedItemActions, currentPage: restPaginationProps.currentPage, pageSize: restPaginationProps.pageSize, handleCustomTablePropChange: handleCustomTablePropChange, paginationSection: restPaginationProps, isPrintMode: isPrintMode })));
};
function mapStateTopProps(state) {
    var _a;
    return {
        isPrintMode: (_a = state.togglePrint) === null || _a === void 0 ? void 0 : _a.status,
    };
}
const mapDispatchToProps = {
    inActivateTrackedItem,
    activateTrackedItem,
};
SystemCreatedTrackedItemsListingContainer.propTypes = {};
export default connect(mapStateTopProps, mapDispatchToProps)(SystemCreatedTrackedItemsListingContainer);
